import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Label } from 'react-bootstrap';
import SearchBox from 'components/site/SearchBox';
import ShipmentWebAPIUtils from 'utils/ShipmentWebAPIUtils';
import { humanize } from 'underscore.string';
import _ from 'underscore';
import { withTranslation } from 'react-i18next';
import { debounce } from 'lodash';
function onSelect(value, item, history) {
    if (item && item._id) {
        history.push(`/shipments/${item._id}`, { id: item._id });
    }
}
class ShipmentSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
        };
        this.search = debounce(this.search, 500);
    }
    clear() {
        this.setState({ items: [] });
    }
    onChange(event) {
        if (this.props.isFilter) {
            this.props.onChange(event);
        }
    }
    search(query) {
        const { invoice, payout, isInvoice, includeAccountingInformation } = this.props;
        const element = isInvoice ? invoice : payout;
        query.page = 1;
        query.per_page = 5;
        query.paginate = false;
        query.select = 'reference_numbers timeline status shipment_id';
        query.unconstrain = true;
        query.includeAccountingInformation = !!includeAccountingInformation;
        if (element && element.type) {
            query.shipment_type = element.type;
        }
        if (element && element.shipper) {
            query.shipper =
                element.shipper && element.shipper._id
                    ? element.shipper._id
                    : element.shipper;
        }
        if (element && element.carrier) {
            query.carrier =
                element.carrier && element.carrier._id
                    ? element.carrier._id
                    : element.carrier;
        }
        ShipmentWebAPIUtils.getShipmentsByReference(query, (res) => {
            this.setState({
                items: res.entity.items || [],
            });
        }, (res) => {
            console.log('Error', res.body);
        });
    }
    handleSearch(input) {
        const item = input.trim().toUpperCase();
        const { isFilter, lineItemGroups } = this.props;
        if (isFilter) {
            this.setState({
                searchItem: item,
            });
            this.setState({
                items: lineItemGroups,
            });
        }
        else if (!_.isEmpty(item === null || item === void 0 ? void 0 : item.trim())) {
            this.setState({
                searchItem: item,
            }, () => {
                this.search({
                    reference: [item],
                });
            });
        }
    }
    renderItem(item) {
        const { isFilter } = this.props;
        let display = isFilter ? item.shipmentId : item.shipment_id;
        let filterValueExists = false;
        if (isFilter) {
            _.each(item.referenceNumbers, (reference) => {
                if (reference.name === 'shipment_id' &&
                    reference.optimized &&
                    reference.optimized.indexOf(this.state.searchItem) > -1) {
                    display = reference.optimized;
                    filterValueExists = true;
                }
            });
            if (filterValueExists) {
                return (React.createElement("a", { key: item._id, id: item._id, className: "list-group-item", style: { cursor: 'pointer' } },
                    React.createElement("h4", { className: "list-group-item-heading" },
                        React.createElement("span", null, display),
                        "\u00A0",
                        React.createElement(Label, { bsStyle: "primary" }, humanize(item.status)))));
            }
            return React.createElement("div", null);
        }
        _.each(item.reference_numbers, (reference) => {
            if (reference.optimized &&
                reference.optimized.indexOf(this.state.searchItem) > -1) {
                display = reference.value;
            }
        });
        return (React.createElement("a", { key: item._id, id: item._id, className: "list-group-item", style: { cursor: 'pointer' } },
            React.createElement("h4", { className: "list-group-item-heading" },
                React.createElement("span", null, display),
                "\u00A0",
                React.createElement(Label, { bsStyle: "primary" }, humanize(item.status)))));
    }
    onSelectionHandler(value, item) {
        const { isFilter } = this.props;
        const onSelection = this.props.onSelect || onSelect;
        let display = isFilter ? item.shipmentId : item.shipment_id;
        if (isFilter) {
            _.each(item.referenceNumbers, (reference) => {
                if (reference.name === 'shipment_id' &&
                    reference.optimized &&
                    reference.optimized.indexOf(this.state.searchItem) > -1) {
                    display = reference.optimized;
                }
            });
        }
        else {
            _.each(item.reference_numbers, (reference) => {
                if (reference.optimized &&
                    reference.optimized.indexOf(this.state.searchItem) > -1) {
                    display = reference.value;
                }
            });
        }
        onSelection(value, item, this.props.history, display);
    }
    render() {
        const { closeOnSelect, onClose, t, dataTestId } = this.props;
        return (React.createElement(SearchBox, { items: this.state.items, clear: () => this.clear(), clearOnSelect: !this.props.isFilter, onChange: (event, nGram) => this.onChange(event, nGram), search: (reference) => this.handleSearch(reference), placeholder: this.props.isFilter
                ? t('FILTER_BY_SHIPMENT_ID_PLACEHOLDER')
                : t('SEARCH_FOR_REFERENCE'), onSelect: (value, item) => {
                this.onSelectionHandler(value, item);
                if (closeOnSelect) {
                    onClose();
                }
            }, renderItem: (item) => this.renderItem(item), nGramLength: 5, testDataId: dataTestId }));
    }
}
ShipmentSearch.propTypes = {
    onSelect: PropTypes.func,
    closeOnSelect: PropTypes.bool,
    onClose: PropTypes.func,
};
ShipmentSearch.propTypes = {
    history: PropTypes.object.isRequired,
    dataTestId: PropTypes.string,
};
export default withRouter(withTranslation()(ShipmentSearch));
